var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.432 8.94273C5.432 7.10814 6.17044 4.77979 7.35909 2.86659C7.94533 1.92278 8.59173 1.15711 9.26244 0.595877L0 0.570312V12.843V14.8305H8.98754V9.43968H5.432V8.94273ZM4.14815 5.96173C4.14815 6.291 3.88282 6.55795 3.55558 6.55795C3.2283 6.55795 2.96297 6.291 2.96297 5.96173V4.1731C2.96297 3.84387 3.2283 3.57688 3.55558 3.57688C3.88282 3.57688 4.14815 3.84387 4.14815 4.1731V5.96173ZM16 0.570312L11.213 0.595877C8.95284 1.27765 6.6693 5.35589 6.43867 8.44581H9.97543V14.8305L16 14.856V0.570312ZM13.0371 5.96173C13.0371 6.291 12.7717 6.55795 12.4445 6.55795C12.1172 6.55795 11.8518 6.291 11.8518 5.96173V4.1731C11.8518 3.84387 12.1172 3.57688 12.4445 3.57688C12.7717 3.57688 13.0371 3.84387 13.0371 4.1731V5.96173Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/mac-icon.svg";
export { ForwardRef as ReactComponent };